module.exports = __webpack_public_path__ + "img/sample_03_big.fff7ba7c.gif";